import React, { FunctionComponent } from 'react';

export type DynamicYieldPlacementProps = {
	dynamicYieldId: string;
};

export const DynamicYieldPlacement: FunctionComponent<DynamicYieldPlacementProps> = ({ dynamicYieldId }) => (
	<div id={`${dynamicYieldId}`} data-testid={`dynamic-yield-placement-div-${dynamicYieldId}`}></div>
);
